import { injectWeeklyContent } from "./inject-weekly-content.js";
import { INJECT_ANCHOR_SELECTOR } from "./config.js";

/**
 * Injiziert Inhalte für alle passenden Kacheln (weekly und bundle) mit einem
 * Concurrency-Limit, um parallele Requests zu begrenzen.
 */
export async function injectWithLimit(root = document, limit = 4, selector = INJECT_ANCHOR_SELECTOR) {
    const queue = [...root.querySelectorAll(selector)];

    const workers = Array.from({ length: Math.max(1, limit) }, async () => {
        while (queue.length) {
            const a = queue.shift();
            await injectWeeklyContent(a);
        }
    });

    await Promise.all(workers);
}
